import * as Yup from 'yup'


/** Pickup Inbound Receiving schema for Exclusive Seller (no maximum quantity) */
const sellerInboundReceivePickupForExclusiveSellerSchema = Yup.object().shape({
  received_quantity: Yup.number()
    .positive('Must be more than 0')
    .min(15, 'Inbound Pickup must have more than 15 quantity.')
    .required('Required'),
  weight      : Yup.number().positive('Must be more than 0').required('Required'),
  tracking_no : Yup.number().positive('Must be positive number').required('Required')
})

export default sellerInboundReceivePickupForExclusiveSellerSchema
